import {apiCall} from './api'

export const INSERT_CARD_FEE = 'INSERT_CARD_FEE'
export const insertCardFee = (identifierType, identifier, amount, feeId) =>({
  type:INSERT_CARD_FEE,
  payload: apiCall('InsertCardFee', {identifierType, identifier, amount, feeId})
})
